import React from 'react'
import './App.css';
// import { withAuthenticator } from '@aws-amplify/ui-react';
import Home from './pages';
import Publications from './pages/publications';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
// import { Auth } from 'aws-amplify'



function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path='/' element={<Home />} exact />
          <Route path='/Publications' element={<Publications />} exact />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
